<template>
    <div>
        <h3>
            {{ customer_style_sheet.style_name }}
        </h3>
        <div style="display: flex; flex-direction: row; flex-wrap: wrap; width: 100%;">

            <div 
                v-for="(data, index) in customer_style_sheet.style_options.filter(t => t.is_default)" 
                :key="index" style="margin: 10px; border: 1px solid #e2e2e2; padding: 20px;">

                    <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 200px;">
                        <span>
                            <b>{{data.master_style_name}}</b>
                        </span>                            
                        <span>
                            {{data.option_name}}
                        </span>
                        <span v-if="data.fabric_choices !== null">
                            <span v-if="data.fabric_choices.filter(t => t.selected).length>0">
                                Fabric: {{ data.fabric_choices.filter(t => t.selected)[0].sku_code }}, {{ data.fabric_choices.filter(t => t.selected)[0].article_name }}
                            </span>
                        </span>
                    </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    props: ['customer_style_sheet'],
    data() {
      return {
      }
    }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/WorkOrder/CustomStyle.vue